import { gql } from '@apollo/client'

export default gql`
  fragment ManagerOfCompanies on Employee {
    id
    managerOfCompanies {
      company {
        id
        name
        network {
          id
          name
        }
      }
    }
  }
`
